import * as React from "react";

function SvgBackupToDatabase(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 25 24" fill="none" {...props}>
      <g clipPath="url(#BackupToDatabase_svg__clip0)" fill="#fff">
        <path d="M19.273 5.107V3.143C19.273 1.412 14.962 0 9.648 0S.023 1.412.023 3.143v1.964c0 1.731 4.311 3.143 9.625 3.143s9.625-1.412 9.625-3.143z" />
        <path d="M19.273 11.436V7.563C17.205 8.986 13.42 9.65 9.648 9.65c-3.772 0-7.557-.663-9.625-2.088v4.42c0 1.731 4.311 3.143 9.625 3.143.577 0 1.141-.017 1.69-.049a6.003 6.003 0 017.935-3.64zM11.044 16.494a5.99 5.99 0 002.321 5.262c-1.144.157-2.4.244-3.717.244-5.314 0-9.625-1.412-9.625-3.143v-4.42c2.068 1.425 5.853 2.088 9.625 2.088.466 0 .933-.01 1.396-.031z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.023 24a7 7 0 100-14 7 7 0 000 14zm0-1a6 6 0 100-12 6 6 0 000 12z"
        />
        <path d="M17.9 22h-1.862c-.31 0-.56-.279-.56-.625v-4.376h-2.042c-.414 0-.622-.56-.328-.888l3.542-3.965a.418.418 0 01.636 0l3.547 3.965c.293.328.086.888-.329.888H18.46v4.376c0 .346-.25.625-.56.625z" />
      </g>
      <defs>
        <clipPath id="BackupToDatabase_svg__clip0">
          <path d="M.023 0h24v24h-24V0z" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgBackupToDatabase;
